export const GET_SURVEY_SUCCESS = '@@survey/GET_SURVEY_SUCCESS';
export const GET_SURVEY_FAILURE = '@@survey/GET_SURVEY_FAILURE';

export const fetchSurveyQuestonsSuccess = surveyQuestionsData => ({
    type: GET_SURVEY_SUCCESS,
    surveyQuestionsData,
});

export const fetchSurveyQuestonsFailure = () => ({
    type: GET_SURVEY_FAILURE,
});
